module.exports = __webpack_public_path__ + "img/Porto Apartment - 34 of 85.905e1ca2.jpeg";